import { render, staticRenderFns } from "./SupervisorEditor.vue?vue&type=template&id=d164a68a&"
import script from "./SupervisorEditor.vue?vue&type=script&lang=js&"
export * from "./SupervisorEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports